import { differenceInCalendarDays } from 'date-fns';
import { dateTimeStringToDate } from '../utils/calendarUtils';
import { IAvailableBookingPeriod } from '@shared/integrations/taf-api/v2/models';

interface IAccommodationPeriodInformation {
    selectedPeriod: IAvailableBookingPeriod;
}

const AccommodationPeriodInformation = ({ selectedPeriod }: IAccommodationPeriodInformation) => {
    return (
        <>
            <div className='d-flex flex-column gap-2 pt-2'>
                {selectedPeriod.startDate && selectedPeriod.endDate ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Period</span>
                        <span>
                            {selectedPeriod.startDate ? dateTimeStringToDate(selectedPeriod.startDate) : 'N/A'} - {selectedPeriod.endDate ? dateTimeStringToDate(selectedPeriod.endDate) : 'N/A'}
                        </span>
                    </div>
                ) : null}
                {selectedPeriod.startDate && selectedPeriod.endDate ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Längd</span>
                        <span>{differenceInCalendarDays(new Date(selectedPeriod.endDate), new Date(selectedPeriod.startDate))}</span>
                    </div>
                ) : null}
            </div>
            {selectedPeriod.bookingFee || selectedPeriod.price ? (
                <div className='d-flex flex-column gap-2 border-top pt-4'>
                    <div className='d-flex justify-content-between gap-2 font-size-lg font-weight-medium'>
                        <span>Summa</span>
                        <span>{(selectedPeriod.bookingFee ?? 0) + (selectedPeriod.price ?? 0)} kr</span>
                    </div>
                </div>
            ) : null}
        </>
    );
};
export default AccommodationPeriodInformation;
